import { Offer, OfferTile, type CategoryGroupType, type IOffer, type IOfferTile, type IOfferTileDto } from "@domain/Marketplace";
import { useMarketplaceApi } from "@app/MyMarketplace/Types/Api/MarketplaceApi";
import type { GpsCoordinates, GpsSearchBoundary } from "@services/GpsCoordinates";
import { OfferListOrderBy } from "../Types/Api/OfferListOrderBy";

export const useOfferService = () => new class
{

    /**
     * Gets an offer using its ID
     * @param offerId 
     * @returns 
     */
    async getOffer( offerId: string, searchBoundary: GpsCoordinates | undefined ): Promise<IOffer|null>
    {
        const api = useMarketplaceApi();
        const dto = await api.getOffer( offerId, searchBoundary );
        return dto ? new Offer( dto ) : null;
    }
    
    /**
     * Gets offers for the given category using the category ID
     * @param categoryGroup 
     * @param categoryId 
     * @param query Optional search term 
     * @returns 
     */
    async getOffersForCategory( searchBoundary: GpsSearchBoundary, categoryGroup: CategoryGroupType, categoryId?: string, query?: string, orderBy: OfferListOrderBy = OfferListOrderBy.NewestFirst, pageNumber: number = 0, pageSize: number = 1000 ): Promise<{ offers: IOfferTile[], count: number }>
    {
        const api = useMarketplaceApi();
        const result = await api.getOffersForCategory( searchBoundary, categoryGroup, categoryId, query, orderBy, pageNumber, pageSize );
        if( !result.success ) return { offers: [], count: 0 };
        return { 
            count: result.data.totalCount, 
            offers: result.data.offers.map( (o:IOfferTileDto) => new OfferTile( o ) ) 
        };
    }

    /**
     * Gets offers for the given search query
     * @param query 
     * @returns 
     */
    async getOffersForQuery( searchBoundary: GpsSearchBoundary, query: string ): Promise<IOfferTile[]>
    {
        const api = useMarketplaceApi();
        const result = await api.getOffersForSearchQuery( searchBoundary, query );
        if( !result.success ) return [];
        return result.data.offers.map( (o:IOfferTileDto) => new OfferTile( o ) );
    }

}
